// src/pages/admin/AllTents.jsx
import React, { useEffect, useState } from "react";
import { ref, onValue, remove, update } from "firebase/database";
import { dimaniwasRtdb } from "../../firebase/config"; // Use Dimaniwas DB
import styles from "./allproduct.module.css";

const AllTents = () => {
  const [tents, setTents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTent, setSelectedTent] = useState(null);
  const [editTent, setEditTent] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const tentsRef = ref(dimaniwasRtdb, "tents");

    const unsubscribe = onValue(tentsRef, (snapshot) => {
      const data = snapshot.val();
      const loadedTents = [];
      for (let key in data) {
        loadedTents.push({ id: key, ...data[key] });
      }
      setTents(loadedTents.reverse());
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const handleDelete = (tentId) => {
    if (window.confirm("Are you sure you want to delete this tent?")) {
      remove(ref(dimaniwasRtdb, `tents/${tentId}`));
    }
  };

  const handleEditChange = (e) => {
    setEditTent({ ...editTent, [e.target.name]: e.target.value });
  };

  const handleEditSave = () => {
    const { id } = editTent;
    const { name, slug, description, price, image } = editTent;
    update(ref(dimaniwasRtdb, `tents/${id}`), { name, slug, description, price: Number(price), image });
    document.getElementById("editClose").click();
  };

  return (
    <div className={`d-flex flex-column flex-md-row ${styles.allProduct_container}`}>
      {/* Sidebar toggle for mobile */}
      <button className="btn btn-dark d-md-none m-2" onClick={() => setSidebarOpen(!sidebarOpen)}>
        ☰ Menu
      </button>

      {/* Sidebar */}
      <div className={`bg-dark text-white p-4 ${styles.sidebar} ${sidebarOpen ? "d-block" : "d-none"} d-md-block`}>
        <h4 className="mb-4">Admin</h4>
        <ul className="nav flex-column" style={{ marginLeft: "-15px" }}>
          <li>
            <a href="/admin/dashboard" className="nav-link text-white">Dashboard</a>
          </li>
          <li>
            <a href="/admin/add-tent" className="nav-link text-white">Add Tent</a>
          </li>
          <li>
            <a href="/admin/all-tents" className="nav-link active text-warning">Manage Tents</a>
          </li>

           <li>
            <a href="/admin/add-feature" className="nav-link text-white">Add Feature</a>
          </li>
          <li>
            <a href="/admin/all-features" className="nav-link text-white">Manage Feature</a>
          </li>
          
        </ul>
      </div>

      {/* Main content */}
      <div className={`p-4 w-100 ${styles.main}`}>
        <h2 className={styles.allProduct_heading}>All Tents</h2>
        {loading ? (
          <p className={styles.allProduct_loader}>Loading...</p>
        ) : tents.length === 0 ? (
          <p className={styles.allProduct_noData}>No tents found.</p>
        ) : (
          <div className={`table-responsive ${styles.allProduct_tableWrapper}`}>
            <table className={`table table-bordered table-striped ${styles.allProduct_table}`}>
              <thead className="table-dark">
                <tr>
                  <th>Image</th>
                  <th>Name</th>
                  <th>Price (per night)</th>
                  <th>Description</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {tents.map((t) => (
                  <tr key={t.id}>
                    <td>
                      <img src={t.image} alt={t.name} className={styles.allProduct_img} />
                    </td>
                    <td>{t.name}</td>
                    <td>₹{t.price}</td>
                    <td>{t.description}</td>
                    <td>
                      <button className="btn btn-sm btn-primary me-1" data-bs-toggle="modal" data-bs-target="#viewModal" onClick={() => setSelectedTent(t)}>
                        View
                      </button>
                      <button className="btn btn-sm btn-warning me-1" data-bs-toggle="modal" data-bs-target="#editModal" onClick={() => setEditTent(t)}>
                        Edit
                      </button>
                      <button className="btn btn-sm btn-danger" onClick={() => handleDelete(t.id)}>Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* View Modal */}
      <div className="modal fade" id="viewModal" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Tent Details</h5>
              <button type="button" className="btn-close shadow-none" data-bs-dismiss="modal" />
            </div>
            <div className="modal-body">
              {selectedTent && (
                <>
                  <img src={selectedTent.image} alt={selectedTent.name} className="img-fluid mb-3" />
                  <p><strong>Name:</strong> {selectedTent.name}</p>
                  <p><strong>Price:</strong> ₹{selectedTent.price}</p>
                  <p><strong>Description:</strong> {selectedTent.description}</p>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Edit Modal */}
      <div className="modal fade" id="editModal" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Tent</h5>
              <button type="button" className="btn-close shadow-none" data-bs-dismiss="modal" id="editClose" />
            </div>
            <div className="modal-body">
              {editTent && (
                <>
                  <div className="mb-2">
                    <label>Name</label>
                    <input type="text" className="form-control shadow-none" name="name" value={editTent.name} onChange={handleEditChange} />
                  </div>
                  <div className="mb-2">
                    <label>Price</label>
                    <input type="text" className="form-control shadow-none" name="price" value={editTent.price} onChange={handleEditChange} />
                  </div>
                  <div className="mb-2">
                    <label>Description</label>
                    <textarea className="form-control shadow-none" name="description" value={editTent.description} onChange={handleEditChange}></textarea>
                  </div>
                </>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn btn-success" onClick={handleEditSave}>Save Changes</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllTents;
